export default {
  criptonomia: 'Criptonomia fornece soluções para:',
  landing: {
    title: 'Criptonomia',
    subtitle:
      'Desenvolvemos soluções com foco em beneficiar processos corporativos com o emprego de tecnologias emergentes.',
    btn: 'Conheça nossas soluções',
    products: [
      {
        title: 'Tokenização de Ativos',
        subtitle:
          'Tokenização de ativos de alto valor agregado com foco no ganho de liquidez para ativos não líquidos e descoberta facilitada de preços.',
      },
      {
        title: 'Registros de documentos',
        subtitle:
          'Registro de documentos e informações sensíveis em Blockchain redundantes para compliance de processos.',
      },
    ],
  },
  mission: {
    obj: [
      {
        title: 'Nossa Missão',
        subtitle:
          'Atacar problemas corporativos de difíceis resolução, alto valor agregado e oferecer tecnologias que promovem excelência e fluidez transacional.',
      },
      {
        title: 'Nossa Visão',
        subtitle:
          'A Criptonomia almeja ser referência na resolução de problemas que podem ser tratados através de tecnologias e processos de ponta com ênfase em protocolos distribuídos.',
      },
      {
        title: 'Porque nós',
        subtitle:
          'Porque nós executamos. Tangibilizamos os projetos baseados em tecnologias abstratas em aplicações que geram valor real.',
      },
    ],
  },
  specialty: {
    title: 'Especialistas em',
    subtitle: 'Blockchain',
    p:
      'A Criptonomia tem especialidade em beneficiar processos corporativos por meio da tecnologia blockchain promovendo um novo patamar de transparência entre clientes e fornecedores, audibilidade de processos e provas de registro.',
    paragraph:
      'Estamos criando soluções abrangentes em tecnologia envolvendo Blockchain para clientes e parceiros, em uma ampla gama de setores como industrial, financeiro e quaisquer tipo de organização que trabalhe com ativos e informações sensíveis.',
  },
  carousel: {
    features: [
      {
        preTitle: 'Conciliação de distribuída pagamentos',
        title:
          'ArcelorMittal incluiu Blockchain no seu radar de tecnologias emergentes para indústria 4.0.',
        description:
          'Foi realizado um processo consultivo com foco no levantamento e seleção de casos de uso para elaboração de um projeto piloto fundamentado na tecnologia Blockchain. O Sistema de conciliação distribuída de pagamentos entre fornecedor e cliente pode transformar uma conciliação contábil-bancária, que relaciona um documento fiscal com a sua devida quitação, de um processo centralizado que pode durar até 24 horas para um colaborativo de aproximadamente 3 minutos, tempo de confirmação da transação na Blockchain do Ethereum.',
      },
      {
        preTitle: 'Tokenização',
        title: 'Tokenização do Real Brasileiro',
        description:
          'O BRLT é um token simétrico para o BRL com paridade de um para um. A criação do BRLT foi motivada pelo desejo de entregar para sociedade brasileira o experimento de um token digital estável, seguro e auditável e capaz de transacionar valor.',
      },
      {
        preTitle: 'Cursos e Palestras',
        title: 'Blockchain para Executivos - Uma abordagem prática',
        description:
          'Blockchain para executivos é um curso prático para C – Levels, Diretores e Gerentes entenderem como aplicar a tecnologia na sua organização de forma a gerar valor real. ​Muito se ouve dizer sobre a tecnologia Blockchain nas reuniões de projeto porém o zeitgeist do cenário corporativo brasileiro é de pouca implementação prática. Se você possui um cargo de tomador de decisão em qualquer setor e quer entender como implementar a tecnologia blockchain para resolver problemas da sua organização junte se a nós',
      },
      {
        preTitle: '“Self-Auditing” para operações financeiras',
        title: 'Registro distribuído de negociação em tempo real',
        description:
          'Atualmente quando nos deparamos com informações de performance sobre estratégias de investimentos ou produtos financeiros nos cabe ter fé no provedor da informação. Geralmente as grandes instituições recorrem à auditoria externa para confirmar a sua atuação no Mercado. Com os produtos da Criptonomia o processo de auditoria de registros fica mais eficiente e econômico. Foi elaborado o True Record um sistema de registro em streaming que grava as operações do cliente na Blockchain no momento que elas ocorreram com uma chave única e publica de modo que qualquer pessoa pode verificar em tempo real o histórico de performance do fundo em questão.',
      },
      {
        preTitle: 'Tokenização de Precatórios',
        title:
          'O Mercado Bitcoin, uma das mais admiradas exchanges de criptoativos do Brasil, tokenizou títulos de precatórios',
        description:
          'Fomos escolhidos como fornecedor técnico para estruturação dos contratos inteligentes que deram origem Faos primeiros tokens de precatorios brasileiros. Atuamos auxiliando-os na estruturação técnica para os primeiros ativos financeiros tokenizados amplamente  negociados na história da América Latina.',
      },
    ],
  },
  callToAction: {
    title: 'CONTRATOS INTELIGENTES SOB MEDIDA',
    subtitle:
      'Nos apresente os problemas do seu setor ou o patamar em transparência e compliance que deseja alcançar e a Criptonomia te ajudará a entender se contratos inteligentes podem alavancar os processos no contexto da sua organização.',
    express: 'Contato Expresso Whatsapp',
  },
  products: {
    title: 'Nossos Produtos',
    lgpdTitle:
      'Como garantir que a sua organização cumpriu boas práticas da LPGD após um vazamento de dados?',
    lgpdSubtitle:
      'Os registros em Blockchain garantidos pela Scryptum podem servir de prova de criptografia e de boas práticas a fim de proteger a sua instituição do risco de multas milionárias.',
    plans: 'Ver os planos',
    know: 'Conhecer solução',
    obj: [
      {
        title: 'SCRYPTUM',
        subtitle:
          'Ferramenta de segurança da informação. Armazene e registre informações sensíveis para escrutínio público, auditoria futura ou conciliação de uma forma economicamente eficiente. Proteja sua organização, processos internos e externos no contexto da LGPD & GPDR.',
        link: 'scryptum',
        h4:
          'Scryptum - Proteção de processos e informações sensíveis inclusive organizacional no contexto',
        p1:
          'Armazene e registre informações sensíveis para comprovação irrefutável no futuro. Graças a tecnologia Blockchain é possível estabelecer registros de forma independente mas que permitem verificação pública.',
        p2:
          'A solução da scryptum tem sido procurada por empresas para resolver problemas/jogos de confiança incompleta na relação de cliente/fornecedor ou parceiros de negócio e como investimento na comprovação de boas práticas para proteção organizacional no contexto da LGPD/GPDR.',
        features: [
          {
            title: 'Registre em Blockchain',
            subtitle:
              'Registre referências criptográficas de informações confidenciais para obter uma prova irrefutável de nenhuma alteração em vários protocolos distribuídos.',
          },
          {
            title: 'Transparência',
            subtitle:
              'Caso a transparência seja desejada, a plataforma mais adequada para o armazenamento de dados é  a Blockchain, caso contrário os dados gravados podem ser armazenados de forma criptografada e só ficarem acessíveis por players do contexto determinado.',
          },
          {
            title: 'Integridade',
            subtitle:
              'Blockchain, uma vez inseridos, os dados ficam imutáveis na rede. A disposição das transações e funcionamento da rede garantem a segurança que seus dados não serão alterados.',
          },
        ],
        featuresMid: [
          {
            title: 'Privacidade e Segredo Industrial',
            subtitle:
              'As referências criptográficas dos dados podem ser armazenadas de uma forma que todo e qualquer segredo industrial é preservado e tratado com o mais alto grau de privacidade.',
          },
          {
            title: 'Remoção de intermediários',
            subtitle:
              'Ao invés de alocar fundos para contratar terceiros para afirmarem que os seus dados são verídicos, existem algumas situações, em que auditores externos podem ser substituídos pelo streaming de gravação em tempo real de dados na Blockchain que cumpre a mesma função das auditorias mais sofisticadas.',
          },
          {
            title: 'Auto-compliance',
            subtitle:
              'Aprimore os processos internos e externos de compliance com fornecedores e parceiros com uma ferramenta que ajuda a garantir paz de espírito institucional contra fraudes, provas de boa administração, contra alegação de imperícia e negligência entre outras garantias.',
          },
        ],
      },
      {
        title: 'TASSET',
        subtitle:
          'TASSET - Uma plataforma segura para emissão de tokens de ativos digitais através da tecnologia Blockchain.',
        link: 'tasset',
        h4:
          'TASSET - Uma plataforma segura para emissão de tokens de ativos digitais através da tecnologia Blockchain.',
        p1:
          'Transforme títulos tradicionais em tokens para fornecer uma variedade de benefícios: maior liquidez, custos de transação mais baixos, tempos de liquidação automatizados e mais rápidos, propriedade fracionada  e, principalmente, transparência e segurança proporcionada pela Blockchain.',
        p2: '',
        features: [
          {
            title: 'Commodities',
            subtitle:
              'Transforme ativos físicos em ativos digitais negociáveis em um mercado com maior liquidez e menor barreira à entrada em classes de ativos tradicionalmente dominadas por investidores institucionais.',
          },
          {
            title: 'Belas Artes',
            subtitle:
              'Permita que os investidores de varejo tenham acesso ao mercado de belas artes e aos artistas uma oportunidade de se beneficiar de suas obras de arte como investimentos equitativos.',
          },
          {
            title: 'Imobiliária',
            subtitle:
              'Ofereça aos investidores de varejo a capacidade de possuir tokens de edifícios, simbolizando seus imóveis e propriedades. Ativos ilíquidos que são muito caros para negociar, como esse, ganham maior liquidez por meio da tokenização.',
          },
        ],
        featuresMid: [
          {
            title: 'Integridade',
            subtitle:
              'Graças à tecnologia Blockchain, uma vez inseridos, os dados são imutáveis ​​na rede. A organização das transações e da operação da rede garante a segurança de que seus dados nunca serão alterados.',
          },
          {
            title: 'Possibilidades',
            subtitle:
              'Crie seu próprio token de segurança que pagam dividendos, compartilham lucros, pagam juros ou investem em outros tokens ou ativos para gerar lucros para os detentores de tokens.',
          },
          {
            title: 'Regular',
            subtitle:
              'Transforme valores mobiliários tradicionais ou seu patrimônio em tokens compatíveis com os regulamentos de segurança.',
          },
        ],
      },
      {
        title: 'HIVE',
        subtitle:
          'Mecanismos de consenso são aplicações especializadas em firmar uma base de confiança absoluta entre duas ou mais organizações.',
        link: 'hivemecanism',
        h4:
          'Mecanismos de consenso são aplicações especializadas em firmar uma base de confiança absoluta entre duas ou mais organizações.',
        p1:
          'Uma aplicação descentralizada não manipulável e não pertencente a nenhuma das duas partes que pode ser usada por ambas de forma isonômica e preservando a segurança da informação. Todas as ações dos participantes bem como estados das medições são registradas naBlockchain e uma câmara de arbitragem é desenvolvida para dirimir disputas.',
        p2: '',
        features: [
          {
            title: 'Prova de Consenso',
            subtitle:
              'Graças a tecnologia Blockchain, conseguimos alcançar o consenso de forma simples. A imutabilidade de registros garante para o bem ou para o mal a autenticidade das informações.',
          },
          {
            title: 'Transparência',
            subtitle:
              'Auditabilidade nas regras de negócio. Nenhum registro ou evidência é adulterado ou some uma vez que são imutáveis e eternos e essas informações e pessoas podem ser auditadas e comparadas a qualquer tempo.',
          },
          {
            title: 'Automação financeira',
            subtitle:
              'Munidos por um contrato inteligente conseguimos realizar a automação completa do fluxo de pagamentos de acordo com as variáveis impostas.',
          },
        ],
        featuresMid: [
          {
            title: 'Técnica e comercial',
            subtitle:
              'Medições e ações dos participantes são registradas na Blockchain, tecnologia estado da arte para registros não manipuláveis.',
          },
          {
            title: 'Financeira',
            subtitle:
              'Pagamento calculado sem interferência humana, podendo ser completamente automatizado.',
          },
          {
            title: 'Jurídica',
            subtitle:
              'Existência de uma câmara de arbitragem, juridicamente válida, implementada na solução para resolver quaisquer conflitos de forma barata, eficiente e rápida.',
          },
        ],
      },
      {
        title: 'EVO',
        subtitle:
          'A EVO é um software completo para negociação de ativos digitais com foco em criptoativos, todavia absolutamente portável para quaisquer outros ativos digitais tokenizados ou não, como títulos bancários, insumos em geral e até commodities como excedentes de energia elétrica.',
        link: 'evo',
        h4:
          'A EVO é um software completo para negociação de ativos digitais com foco em criptoativos, todavia absolutamente portável para quaisquer outros ativos digitais tokenizados ou não, como títulos bancários, insumos em geral e até commodities como excedentes de energia elétrica.',
        p1:
          'Nossa plataforma web conta com um motor de ordens robusto capaz de gerir 2000+ ordens concomitantes por minuto em uma infraestrutura básica. API documentada e biblioteca própria que facilita integração de robôs de investimento.',
        p2:
          'Nossa aplicação Mobile é robusta com todas as funcionalidades da plataforma web na palma das mãos.',
        features: [
          {
            title: 'Interface Amigável',
            subtitle:
              'A plataforma possui um layout limpo que inclui uma direção clara para usuários iniciantes e mais avançados.',
          },
          {
            title: 'Liberdade',
            subtitle:
              'A plataforma foi pensada para ser adaptável. Customize o ambiente front-end para adequar à sua demanda.',
          },
          {
            title: 'Suporte',
            subtitle:
              'Suporte sênior de até 24h por dia 7 dias por semana com tempo de resposta imediato.',
          },
          {
            title: 'Wallet',
            subtitle:
              'Endereços de carteira gerados automaticamente; Autenticação segura de dois fatores do Google; Integre carteiras de armazenamento a frio para uma maior segurança.',
          },
          {
            title: 'Motor de Ordem robusto',
            subtitle:
              'O algoritmo implementado para o processamento de ordens foi pesquisado e elaborado in-house de forma que suporta 2000+ ordens concomitantes por minuto em uma infraestrutura básica.',
          },
          {
            title: 'Tipos sofisticado de ordens',
            subtitle:
              'Ferramenta avançada de trading que conta com ordens Market, Limit, Stop-Market, Stop-Limit e outras sob demanda. Apoia as estratégias de negociação que envolvem proteção do capital e permite que os usuários possam dormir tranquilos.',
          },
        ],
        featuresMid: [
          {
            title: 'Segurança por protocolo',
            subtitle:
              'A plataforma foi projetada como um dos pilares de segurança da solução como um todo. Toda a troca de informações é criptografada ponta a ponta com algoritmos que são estado da arte da criptografia legada como o Diffie–Hellman.',
          },
          {
            title: 'Negociação fluída',
            subtitle:
              'A EVO conta com um motor de ordens robusto, backoffice/administrativo, área do cliente e integração com múltiplos protocolos descentralizados. Em 2018 uma bolsa com a tecnologia da Evo chegou a ter 64 diferentes tokens listados.',
          },
          {
            title: 'Customização convidativa',
            subtitle:
              'Plataforma com interface customizável com diferentes elementos técnicos para negociação de ativos fornecida em três línguas base: Inglês, Espanhol e Português',
          },
        ],
      },
    ],
  },
  sendMail: {
    title: 'Não recebeu o link de confirmação? Clique aqui para reenviar',
    success: 'Agradecemos a intenção! Em breve entraremos em contato',
    error: 'Foi encontrado um erro ao enviar o e-mail. Favor tentar novamente mais tarde :(.',
    resend: 'Reenviar',
  },
  customers: {
    title: 'Nossos Clientes',
    subtitle:
      'Entregamos soluções práticas e acessiveis ao mercado com máxima qualidade, agilidade e segurança.',
    testimony: [
      {
        name: 'Bernardo Castro Vitorino',
        title: 'CEO - Health Link International',
        testimonial:
          'A empresa foi responsável pelo desenvolvimento da plataforma de registro da performance em blockchain que posiciona a Tempus no estado da arte em transparência financeira.',
      },
      {
        name: 'Leonardo I. R. de Carvalho',
        title: 'CEO, Nftfy - Decentralized NFT Fractionalization',
        testimonial:
          'A Criptonomia reune alguns dos maiores especialistas técnicos e de negócio de Blockchain da America Latina. São capazes de dar vazão à grandes projetos em prazos razoáveis.',
      },
    ],
  },
  partners: {
    title: 'Nossos Parceiros',
    subtitle:
      'Esses são alguns de nosssos parceiros que nos auxiliam na construção de nossas soluções.',
  },
  contactUs: {
    title: 'Contate-nos agora!',
    adress: 'Alameda do Ingá, 16 - 2º andar Vale do Sereno, Nova Lima/MG',
    number: '+55 31 99707 6411',
    email: 'contato@criptonomia.com',
    name: 'Nome:',
    emailForm: 'E-mail:',
    company: 'Empresa:',
    intention: 'Intenção:',
    send: 'Enviar',
    asset: 'Sabemos valorizar o ativo mais escasso do homem.',
  },
  testimony: {
    title: 'Alguns Depoimentos',
  },
  footer: {
    allRights: '© Criptonomia 2021. All Rights Reserved',
    follow: 'Siga-nos',
  },
  links: [
    {
      title: 'Início',
      route: '/home',
    },
    {
      title: 'Sobre',
      route: '/about',
    },
    {
      title: 'Produtos',
      route: '/products',
    },
    {
      title: 'Contato',
      route: '/contact',
    },
  ],
};
